import { c as _c } from "react/compiler-runtime";
import { EmptyPage } from "@components/common/empty-page/empty-page";
import { getSvgColoredIconCss, TABS_CONTENT_PADDING } from "@utils/ui-utils";
import { Grid } from "@mui-wrapper";
import { ProjectMarkupsTable } from "@pages/project-details/project-markups/project-markups-table";
import { PROJECT_MARKUPS_TABLE_COLUMNS, PROJECT_MARKUPS_TABLE_DEFAULT_VISIBLE_COLUMNS, ProjectMarkupsTableHeaders } from "@pages/project-details/project-markups/project-markups-table-utils";
import { ColumnPreferencesProvider } from "@context-providers/table/column-preferences-provider";
import { useMembers } from "@hooks/use-members";
import { useMemo } from "react";
import { MarkupProvider } from "@context-providers/markup/markup-context";
import { useAppSelector } from "@store/store-helper";
import { markupsIElementsFetchingStatusSelector } from "@store/sdb-i-elements/sdb-i-elements-selectors";
import { markupsSelector } from "@store/markups/markups-selector";
import { areCompanyMembersLoadingSelector } from "@store/members/members-selector";
import { selectIsProjectLoading } from "@store/i-elements/i-elements-selectors";
import { NoAnnotationsDuoIcon, XMarkCircleFillIcon } from "@flat-ui";
import { PALETTE_VARS } from "@styles/palette-vars";

/**
 * Renders the project markups as a table
 */
export function ProjectMarkups(t0) {
  const $ = _c(9);
  const {
    projectId
  } = t0;
  const markups = useAppSelector(markupsSelector);
  const markupsIElementsFetchingStatus = useAppSelector(markupsIElementsFetchingStatusSelector);
  const hasFetchedMarkupsIElements = markupsIElementsFetchingStatus === "succeeded";
  const isFetchingMarkups = markupsIElementsFetchingStatus === "uninitialized" || markupsIElementsFetchingStatus === "pending";
  const isProjectLoading = useAppSelector(selectIsProjectLoading);
  const {
    isFetchingProjectMembers,
    hasPermissionToViewMembers
  } = useMembers();
  const areCompanyMembersLoading = useAppSelector(areCompanyMembersLoadingSelector);
  const isLoading = isFetchingProjectMembers || isFetchingMarkups || hasPermissionToViewMembers && areCompanyMembersLoading || isProjectLoading;
  let t1;
  if ($[0] !== hasFetchedMarkupsIElements || $[1] !== isLoading || $[2] !== markups || $[3] !== projectId) {
    t1 = markups.length === 0 && !isLoading ? <EmptyPage title={hasFetchedMarkupsIElements ? "No annotations" : "Error"} subtitle={hasFetchedMarkupsIElements ? "There aren't annotations to show for this project." : "Failed to fetch the project annotations. Please reload the page and try again."} icon={hasFetchedMarkupsIElements ? NoAnnotationsDuoIcon : _temp} /> : <MarkupProvider projectId={projectId} markups={markups}><ColumnPreferencesProvider tableKey="project-markups-table" columns={PROJECT_MARKUPS_TABLE_COLUMNS} options={{
        nonConfigurableColumns: [ProjectMarkupsTableHeaders.options],
        defaultVisibleColumns: PROJECT_MARKUPS_TABLE_DEFAULT_VISIBLE_COLUMNS
      }}><ProjectMarkupsTable isLoading={isLoading} projectId={projectId} /></ColumnPreferencesProvider></MarkupProvider>;
    $[0] = hasFetchedMarkupsIElements;
    $[1] = isLoading;
    $[2] = markups;
    $[3] = projectId;
    $[4] = t1;
  } else {
    t1 = $[4];
  }
  const content = t1;
  let t2;
  if ($[5] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = {
      mt: TABS_CONTENT_PADDING,
      width: "100%"
    };
    $[5] = t2;
  } else {
    t2 = $[5];
  }
  let t3;
  if ($[6] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = {
      width: "100%"
    };
    $[6] = t3;
  } else {
    t3 = $[6];
  }
  let t4;
  if ($[7] !== content) {
    t4 = <Grid container={true} sx={t2}><Grid sx={t3}>{content}</Grid></Grid>;
    $[7] = content;
    $[8] = t4;
  } else {
    t4 = $[8];
  }
  return t4;
}
function _temp() {
  return <XMarkCircleFillIcon sx={{
    ...getSvgColoredIconCss(PALETTE_VARS.error.main),
    width: "61px",
    height: "61px"
  }} />;
}